<div class="dcp-custom-form dcp p-2">
    <label class="form-label" style="
    font-size: 18px;
    display: flex;
    gap: 6px;
"><span class="text-dark">Reason:</span> <strong>{{reasonValue}}</strong></label>
    <div class="d-flex justify-content-end align-items-center mt-3">
        <button class="btn btn-outline-primary me-2" [disabled]="isLoading" type="button" mat-dialog-close>
            Cancel
        </button>
        @if(data?.item?.type == 'add') {
        <button class="btn btn-primary" type="button" [disabled]="isLoading" (click)="submitForm()">
            {{ isLoading ? 'Adding...' : 'Add Reason' }}
        </button>
        } @else if (data?.item?.type == 'delete') {
        <button class="btn btn-primary" type="button" [disabled]="isLoading" (click)="submitForm()">
            {{ isLoading ? 'Deleting...' : 'Delete Reason' }}
        </button>
        }
        @else if(data?.item?.type == 'update') {
        <button class="btn btn-primary" type="button" [disabled]="isLoading" (click)="submitForm()">
            {{ isLoading ? 'Updating...' : 'Update Reason' }}
        </button>
        }

    </div>
</div>
